<div class="agendar-horarios-container">
  <!-- Header -->
  <div class="header">
    <div class="header-content">
      <div class="user-info">
        <span class="user-name">Claudio - A</span>
      </div>
      <div class="header-actions">
        <button class="btn-close">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <!-- Main Area -->
    <div class="main-area">
      <!-- Top Controls -->
      <div class="top-controls">
        <!--<div class="left-controls">
          <button class="btn btn-secondary" (click)="toggleFiltros()">
            Esconder Filtros
          </button>
        </div>-->

                <div class="center-controls">
          <!-- Assessor Filter -->
          <div class="assessor-filter">
            <label class="filter-label">Assessor</label>
            <div class="select-container">
              <select class="form-control" [(ngModel)]="assessorSelecionado" (ngModelChange)="onAssessorChange()">
                <option value="" disabled *ngIf="loading">Carregando assessores...</option>
                <option value="" disabled *ngIf="!loading && assessores.length === 0">Nenhum assessor encontrado</option>
                <option *ngFor="let assessor of assessores" [value]="assessor.id">
                  {{ assessor.text }}
                </option>
              </select>
              <i class="fa fa-chevron-down select-arrow"></i>
            </div>
          </div>

          <!-- Central Controls -->
          <div class="central-controls">
            <div class="type-buttons">
              <button class="btn-type" [class.active]="tipoSelecionado === 'online'" (click)="selecionarTipo('online')">
                Online
              </button>
              <button class="btn-type" [class.active]="tipoSelecionado === 'presencial'" (click)="selecionarTipo('presencial')">
                Presencial
              </button>
            </div>

            <div class="month-display">
                {{ mesAnoLabel }}
            </div>
          </div>

          <button class="btn btn-primary cadastro-rapido-btn" (click)="cadastroRapido()">
            Cadastro Rápido de Cliente
          </button>
        </div>
      </div>

      <!-- Schedule Content -->
      <div class="schedule-content">
        <div class="schedule-list">
          <div class="d-flex gap-2 mb-3">
            <button class="btn btn-outline-secondary btn-sm" (click)="navegarAnterior()">
              <i class="fa fa-chevron-left"></i> Mês anterior
            </button>
            <button class="btn btn-outline-secondary btn-sm" (click)="irParaHoje()">
              Hoje
            </button>
            <button class="btn btn-outline-secondary btn-sm" (click)="navegarProximo()">
              Próximo mês <i class="fa fa-chevron-right"></i>
            </button>
          </div>

          <div class="date-section" *ngIf="loadingHorarios">
            <h3 class="date-title">Carregando horários...</h3>
          </div>

          <div class="date-section" *ngIf="!loadingHorarios && diasAgenda.length === 0">
            <h3 class="date-title">Nenhum horário disponível para os filtros atuais.</h3>
          </div>

          <div class="date-section" *ngFor="let dia of diasAgenda">
            <h3 class="date-title">{{ dia.diaSemanaNome }} - {{ dia.data }}</h3>
            <div class="time-slots">
              <button
                class="time-slot"
                [class.time-slot-presencial]="isHorarioPresencial(horario.presencialOnline)"
                *ngFor="let horario of dia.horarios"
                (click)="selecionarHorario(dia, horario)">
                {{ horario.inicio }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 